import * as React from 'react'
import styled from 'styled-components'

const SelectableList = styled.div`
  overflow: hidden;

  ${ props => props.theme.selectableListOnComputerWithOuterBorder && `
    @media (min-width: ${ props.theme.breakpoints.m}px) {
      border: 1px solid ${ props.theme.colors.clr_0 };
      border-radius: 0.25em;
    }
  `}
`

export const SelectableListItem = styled.div<{ $selected?: boolean }>`
  cursor: pointer;
  line-height: 1.3em;
  font-size: 0.875em;
  border-bottom: 1px solid #d7dde1;
  transition: all 0.3s ease-in-out;
  padding: 0.625em 0.75em 0.75em 0.75em;

  &:first-child {
    border-top: 1px solid ${ props => props.theme.colors.clr_0_lighten_altenate };
  }

  @media (max-width: ${props => props.theme.breakpoints.m}px) {
    text-align: center;
    padding: 1em 0.85714em 1em 0.85714em;
  }
  
  ${ props => props.$selected && `
    background: ${ props.theme.colors.clr_3_lighten };
    font-weight: bold;
  ` }

  ${ props => !props.$selected && `
    &:hover { background: #f7fafc; }
    background: #FFF;
  ` }
`

interface Props<U> {
  data: U[]
  name?: string
  value: U | U[]
  className?: string
  formatter?: (item: U) => React.ReactNode
  cssIdGenerator?: (item: U) => string
  isDisabled?: (item: U) => boolean
  onChange: (selected: U) => void
}

export default function SelectableListComponent<U> ({ data, name, value, className, formatter, cssIdGenerator, isDisabled, onChange }: Props<U & { text?: string }>) {
  return <SelectableList className={ className } id={ `js-test-selectable-list-${name}` }>
    { data.map((item, index) => <SelectableListItem
      id={ cssIdGenerator ? cssIdGenerator(item) : (name ? `${name}${index}` : '') }
      key={ index }
      children={ formatter ? formatter(item) : item.text }
      onClick={ () => (!isDisabled || !isDisabled(item)) && onChange(item) }
      $selected={ Array.isArray(value) ? value.includes(item) : item === value } />) }
  </SelectableList>
}
